/**
 * ID generator plug in
 */
const idPlugin = {
  /**
   * ID generator plug in installer
   *
   * @param {object} Vue Vue instance
   */
  install ( Vue ) {
    /**
     * The starting ID index
     */
    let globalIdIndex = 0;

    Vue.mixin( {
      /**
       * When a component is created, assign it a local component ID from the
       * global ID, then increment the global ID
       */
      beforeCreate () {
        this.componentIdIndex = globalIdIndex.toString();
        globalIdIndex += 1;
      }
    } );

    /**
     * Generate an id using the base ID value provided.
     * The ID will be in the format "uid-{index}-{baseId}"
     *
     * @param {string} baseId The base ID value
     *
     * NOTE: Do not turn this into an arrow function as it relies on "this" being bound to the
     * calling component, which it won't be if an fat arrow function is used
     */
    Vue.prototype.$id = function( baseId ) {
      return `uid-${this.componentIdIndex}-${baseId}`;
    };
  }
};

export default idPlugin;
